export default __webpack_public_path__ + "static/media/plier.0bebad36.PNG";